<h5>{{Title}}</h5>
<div class="align-middle">
    <input type="text" class="form-control" width="400" placeholder="scan a barcode" #barcode (keyup.enter)="barCodeScanned($event)" />
</div>
